'use strict';

/**
 *  1) Styles at the top of file.
 *  !!! Do not delete, this is for webpack building. !!! All scss files must be included in /assets/src/scss/main.scss
 */
import '../scss/main.scss';

/**
 * 2) Import External (3d-part) JS/jQuery Libs, Extensions like: bootstrap, datepicker, fadeSlider, ect.
 * !!! Import Only required components of Bootstrap (NOT whole library).
 */
import 'slick-carousel/slick/slick.min.js';

/**
 *  3) Your custom modules and call function here
 */

import { slickSliders } from "./modules/slick-slider";
import { header } from "./modules/header";
jQuery(document).on("ready", function () {
  header();
  slickSliders();
  // var rellax = new Rellax('.rellax');

  document.getElementById('aiSearchToggle').addEventListener('change', function () {
    var textSpan = this.nextElementSibling.querySelector('.ai-toggle-text');
    textSpan.textContent = this.checked ? 'On' : 'Off';
    textSpan.style.marginLeft = this.checked ? '15px' : '5px';
  });
  document.getElementById('aiSearchToggleTwo').addEventListener('change', function () {
    var textSpan = this.nextElementSibling.querySelector('.ai-toggle-text');
    textSpan.textContent = this.checked ? 'On' : 'Off';
    textSpan.style.marginLeft = this.checked ? '15px' : '5px';
  });
});
(function () {
  var adLocked = false;
  function lockAdImage() {
    // console.log("🟢 lockAdImage() triggered!"); // Checkpoint 1

    var layer = document.getElementById('m-rv-lock-layer');
    if (!layer) {
      // console.log("❌ Stopped: #m-rv-lock-layer element not found on this page.");
      return;
    }
    if (adLocked) {
      // console.log("❌ Stopped: Ad is already locked.");
      return;
    }

    // console.log("⏳ Starting 8-second polling sequence..."); // Checkpoint 2

    var poll = setInterval(function () {
      var imgs = layer.querySelectorAll('img');
      var anchor = layer.querySelector('a[href]');
      var destinationUrl = anchor ? anchor.getAttribute('href') : null;
      var currentBg = window.getComputedStyle(layer).backgroundImage;
      var hasBgImage = currentBg && currentBg !== 'none';

      // console.log(`Polling... Found ${imgs.length} images. Computed BG:`, currentBg); // Checkpoint 3

      // --- CASE 1: The ad is an actual <img> element ---
      if (imgs.length > 0) {
        imgs.forEach(function (img) {
          if (!adLocked && (img.naturalWidth > 100 || img.width > 100)) {
            // console.log("🎉 Case 1 matched! Locking via <img> element.");
            adLocked = true;
            clearInterval(poll);
            var finalSrc = img.src;
            if (finalSrc.includes('934acf30ccc59259b28abb5346e08217')) {
              layer.parentElement.style.display = 'none';
            }
            Object.assign(layer.style, {
              backgroundImage: 'url("' + finalSrc + '")',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              opacity: '1',
              zIndex: '1',
              cursor: 'pointer'
            });
            applyWrapperClick(destinationUrl);
            layer.innerHTML = '';
          }
        });
      }
      // --- CASE 2: No <img> elements, but a CSS background image exists ---
      else if (!adLocked && hasBgImage) {
        // console.log("🎉 Case 2 matched! Locking via CSS Background Image.");
        adLocked = true;
        clearInterval(poll);
        if (currentBg.includes('934acf30ccc59259b28abb5346e08217')) {
          layer.parentElement.style.display = 'none';
        }
        Object.assign(layer.style, {
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          opacity: '1',
          zIndex: '1',
          cursor: 'pointer'
        });
        applyWrapperClick(destinationUrl);
        layer.innerHTML = '';
      }
    }, 100);
    function applyWrapperClick(url) {
      if (url) {
        var wrapper = document.getElementsByClassName('m-rv-wrapper')[0];
        if (wrapper) {
          wrapper.onclick = function () {
            window.open(url, '_blank');
          };
        }
      }
    }
    setTimeout(function () {
      // console.log("🛑 Polling stopped (8-second timeout reached).");
      clearInterval(poll);
    }, 8000);
  }
  window.addEventListener('load', lockAdImage);
  window.addEventListener('pageshow', lockAdImage);

  // Expose globally for console testing
  window.testLockAd = lockAdImage;
})();
document.addEventListener('DOMContentLoaded', function () {
  var mediaQuery = window.matchMedia('(max-width: 991.9px)');
  function handleDynamicText(e) {
    // Included .michelin in the query selector
    var targets = document.querySelectorAll('.badge-price, .top-location, .michelin');
    targets.forEach(function (container) {
      container.childNodes.forEach(function (node) {
        // Target only raw text nodes (ignoring <strong> and <svg>)
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.originalText === undefined) {
            node.originalText = node.textContent;
          }
          node.textContent = e.matches ? '' : node.originalText;
        }
      });
    });
  }

  // Initial check
  handleDynamicText(mediaQuery);

  // Screen resize listener
  mediaQuery.addEventListener('change', handleDynamicText);
});
document.querySelectorAll('.options-list li').forEach(function (li) {
  li.addEventListener('click', function () {
    var openList = document.querySelector('.search-bar-wrapper .custom-dropdown.is-open');
    // console.log(openList);
    if (openList) {
      // Defer removal so it runs AFTER competing scripts finish toggling
      setTimeout(function () {
        openList.classList.remove('is-open');
      }, 0);
    }
  });
});